import cn from "classnames";
import { dateTimeToView, humanizedTimeRange } from "helpers/date";
import moment from "moment";
import Tooltip from "rc-tooltip";
import React from "react";

const CarInfo = (props) => {
    const { item, params } = props;
    const { byPlanDate } = params;
    const { planEndDate, estimatedLeaveDate, estimationComment } = item;
    const cNames = cn("d-flex overflow-auto", {
        "text-danger": moment(estimatedLeaveDate) > moment(planEndDate),
        "text-success": moment(estimatedLeaveDate) <= moment(planEndDate),
    });
    const datesInSameDay = moment(estimatedLeaveDate).dayOfYear() === moment(planEndDate).dayOfYear();
    return item.withoutBidPeriod ? (
        <div className="d-flex overflow-hidden">
            <small className="text-danger">(без заявки {humanizedTimeRange(item.withoutBidPeriod)})</small>
        </div>
    ) : (
        <div className={cNames}>
            <small>
                (
                <Tooltip destroyTooltipOnHide overlay="Плановое время выезда" placement="bottom">
                    <span>{dateTimeToView(planEndDate, datesInSameDay || byPlanDate ? "HH:mm" : "DD.MM HH:mm")}</span>
                </Tooltip>
                &nbsp;/&nbsp;
                <Tooltip
                    destroyTooltipOnHide
                    overlay={
                        <div>
                            Расчетное время выезда
                            {estimationComment && (
                                <>
                                    <br />
                                    <i>{estimationComment}</i>
                                </>
                            )}
                        </div>
                    }
                    placement="bottom"
                >
                    <span>
                        {dateTimeToView(estimatedLeaveDate, datesInSameDay || !byPlanDate ? "HH:mm" : "DD.MM HH:mm")}
                    </span>
                </Tooltip>
                )
            </small>
        </div>
    );
};

export default CarInfo;
